import React, { useState, useEffect, useCallback } from "react";
import { Container, Row, Col, Form, Button, Alert } from "react-bootstrap";
import AppLoader from "../../components/AppLoader/appLoader";
import { useDispatch, useSelector } from "react-redux";
import { useToasts } from "react-toast-notifications";
import { apiHandler } from "../../api";

function Settings() {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [validationError, setValidationError] = useState("");

  const dispatch = useDispatch();
  const { authData,storeId } = useSelector((state) => state.loginSlice);
  const { addToast } = useToasts();

  const passwordRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+{}\[\]:;<>,.?~\\/-]).+$/;

  const handleSettingsUpdate = useCallback(
    async (e) => {
      e.preventDefault();
      setValidationError(""); // Clear old error

      if (!passwordRegex.test(newPassword)) {
        setValidationError(
          "Password must contain at least one uppercase letter, one number, and one special character (e.g., @, #, $, %)."
        );
        return;
      }

      try {
        setLoading(true);
        const url = "https://ondcidentitybackend.clouddeploy.in/api/v1/auth/changePassword";
        const payload = {
          oldPassword,
          newPassword,
        };

        const response = await apiHandler({
          url,
          method: "POST",
          data: JSON.stringify(payload),
          headers: {
            "Content-Type": "application/json",
          },
          authToken: authData,
          dispatch,
          storeId
        });

        

        const responseStatus = response?.data?.statusCode || response?.statusCode;



        if (responseStatus === 201 || responseStatus === "success") {
          addToast("Password Changed successfully!", {
            appearance: "success",
            autoDismiss: true,
          });
          setOldPassword("");
          setNewPassword("");
        } else {
          setValidationError(response?.data?.response?.data?.message || "Failed to update password");
        }
      } catch (error) {
   

        setValidationError(
          "Failed to update password"
        );
      } finally {
        setLoading(false);
      }
    },
    [oldPassword, newPassword, authData, dispatch, addToast]
  );

  return (
    <>
      {loading ? (
        <AppLoader />
      ) : (
        <Container
          fluid
          className="d-flex justify-content-center align-items-center"
          style={{ minHeight: "100vh" }}
        >
          <Row className="w-100">
            <Col
              md={6}
              className="mx-auto"
              style={{
                border: "1px solid #ebebebff",
                padding: "40px",
                borderRadius: "12px",
                boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
                backgroundColor: "#ffffff",
              }}
            >
              <Form onSubmit={handleSettingsUpdate}>
                

                <Form.Group className="mb-3" controlId="formOldPassword">
                  <Form.Label>Old Password</Form.Label>
                  <Form.Control
                    type="password"
                    placeholder="Enter old password"
                    value={oldPassword}
                    onChange={(e) => setOldPassword(e.target.value)}
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3" controlId="formNewPassword">
                  <Form.Label>New Password</Form.Label>
                  <Form.Control
                    type="password"
                    placeholder="Enter new password"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    required
                  />
                 {validationError && (
    <div style={{ color: "red", fontSize: "0.875rem", marginTop: "4px" }}>
      {validationError}
    </div>
  )}
                </Form.Group>

                <Button variant="primary" type="submit">
                  Save Password
                </Button>
              </Form>
            </Col>
          </Row>
        </Container>
      )}
    </>
  );
}

export default Settings;
